module.exports = __webpack_public_path__ + "img/keydata.ac3954fd.png";